import { render, staticRenderFns } from "./OnlineOrderGTINDetail.vue?vue&type=template&id=0af4dacc&scoped=true&"
import script from "./OnlineOrderGTINDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderGTINDetail.vue?vue&type=script&lang=js&"
import style0 from "./OnlineOrderGTINDetail.vue?vue&type=style&index=0&id=0af4dacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4dacc",
  null
  
)

export default component.exports